<template>
  <div class="row pt-3 px-md-5 mx-md-5 mx-1 mb-5 justify-content-center">
    <div class="col-12 text-center mt-3" v-if="mostrar_tiempo_restante">
        Tienes hasta las <b>{{fecha_hora_fin}}</b> de hoy
      </div>
    <div class="col-12 mt-3 text-center">
      <h4>Ansiedad Beck</h4>
    </div>
    <div class="col-md-10 mt-5">
      <div v-bind:class="loading">
        <div class="d-flex justify-content-center">
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div v-show="!antecedentes" v-bind:class="result">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Elige una opción</th>
              <th scope="col" class="text-center"></th>
            </tr>
          </thead>
          <tbody v-for="pregunta of examen.preguntas" v-if="pregunta.active">
            <tr>
              <td rowspan="3">{{pregunta.numero}}</td>
              <td>
                <div class="row">
                  <div
                    v-for="respuesta of pregunta.respuestas"
                    v-on:click="Seleccionar_Respuesta(pregunta.numero, respuesta.numero, respuesta.valor)"
                    class="col-12 border-secondary pb-3 mb-3 border-bottom select_respuesta">
                    <div class="row">
                      <div class="col-9">
                        {{respuesta.respuesta}}
                      </div>
                      <div class="col-3">
                        <i
                          v-if="pregunta.respuesta===respuesta.numero" class="fas fa-check" />
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <!--
          <div class="form-check col-12 px-5 px-md-1 justify-content-center mt-3 text-center">
            <input class="form-check-input" v-on:change="Validar_Que_Esten_Contestadas_Todas_Las_Respuestas" v-model="continuar_siguiente_pregunta_al_contestar" type="checkbox" value="" id="contestar_siguiente_pregunta">
            <label class="form-check-label" for="contestar_siguiente_pregunta">
              Continuar siguiente pregunta automáticamente
            </label>
          </div>
        -->
          <div class="col-12 text-center mt-3">
            <button
              :disabled="validando"
              class="btn btn-success mr-3"
              v-if="pregunta_actual>1"
              v-on:click="Anterior_Pregunta">
              <i class="fas fa-arrow-circle-left"></i>
              Anterior
            </button>
            <button
              class="btn btn-success"
              :disabled="
                puedo_continuar==0
                ||
                validando
              "
              v-on:click="Continuar_Siguiente_Pregunta">
              Siguiente
              <i class="fas fa-arrow-circle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-show="antecedentes" v-bind:class="result">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col" class="text-center">Pregunta</th>
              <th scope="col" class="text-center">Si</th>
              <th scope="col" class="text-center">No</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pregunta of preguntas_antecedentes">
              <td>{{pregunta.numero}}</td>
              <td>{{pregunta.pregunta}}</td>
              <td
                style="cursor:pointer;"
                v-on:click="pregunta.respuesta=1">
                <i
                  v-if="pregunta.respuesta==1"
                  class="fas fa-check" />
              </td>
              <td
                style="cursor:pointer;"
                v-on:click="pregunta.respuesta=2">
                <i
                  v-if="pregunta.respuesta==2"
                  class="fas fa-check" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-12 text-center">
            <button
              v-on:click="Guardar_Antecedentes"
              :disabled="!puedo_terminar"
              class="btn btn-success">
              Terminar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!antecedentes" class="col-12 mt-5 text-center">
      <h5>Pregunta <b>{{pregunta_actual}}</b> / {{total_preguntas}}</h5>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      validando:false,
      fecha_hora_fin:null,
      cantidad_siguiente:1,
      continuar_siguiente_pregunta_al_contestar:false,
      examen:{
        idexamen:null,
        abreviatura:"depBeck",
        nombre:"Ansiedad Beck",
        avance:70,
        preguntas:[]
      },
      antecedentes:false,
      preguntas_antecedentes:[
        {
          numero:1,
          pregunta:"He pagado una sentencia por algún delito o crimen que cometí",
          respuesta:null,
        },
        {
          numero:2,
          pregunta:"He cometido un crimen mayor el cual, no ha sido juzgado",
          respuesta:null,
        },
        {
          numero:3,
          pregunta:"He sido investigado por un crimen o un delito",
          respuesta:null,
        },
      ],
      pregunta_actual:1,
      avance:0,
      total_preguntas:0
    }
  },
  methods:{
    Buscar_Pregunta_Que_Se_Quedo(){
      var si_hay_contestadas=false;
      var i_contestada=null;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        this.examen.preguntas[i].active=false;
        if (this.examen.preguntas[i].respuesta!=null) {
          if (i>0) {
            this.examen.preguntas[i-1].active=false;
          }
          this.examen.preguntas[i].active=true;
          this.pregunta_actual=this.examen.preguntas[i].numero;
          i_contestada = i;
          si_hay_contestadas=true;
        }
      }
      if (!si_hay_contestadas) {this.examen.preguntas[0].active=true;}
    },
    Guardar_Avance(es_ultima){
      //solo enviar las respuestas de cada pregunta
      var preguntas=[];
      this.antecedentes=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].cambio==true) {
          preguntas.push({
            numero:this.examen.preguntas[i].numero,
            respuesta:this.examen.preguntas[i].respuesta,
            valor:this.examen.preguntas[i].valor
          });
        }
      }
      if (es_ultima) {

          this.Cargando();

      }
      if (preguntas.length>0) {
        //post del avance
        this.$http.post('solicitudes/examen/avance',{
          tiempo_restante:this.tiempo_restante,
          avance:this.avance,
          idexamen:this.examen.idexamen,
          preguntas:preguntas
        })
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
          if (respuestaJson.resp=='Excelente') {
            for (var i = 0; i < preguntas.length; i++) {
              for (var y = 0; y < this.examen.preguntas.length; y++) {
                if (this.examen.preguntas[y].numero==preguntas[i].numero) {
                  this.examen.preguntas[y].cambio=false;
                }
              }
            }
            if (es_ultima) {
              //this.antecedentes=true;
              //this.Consultar_Preguntas_Adicionales();
              this.$router.push({name:'Examenes'});
            }
          }
          else if (respuestaJson.resp=='Se terminó el tiempo') {
            setTimeout(function(){
              swal('Se terminó el tiempo',"", "error");
            },1000);
            this.$router.push({name:'Login'});
          }
          else{
            if (es_ultima) {
              this.Listo();
            }
            swal(respuestaJson.resp,"", "error");
          }
        })
        .catch(error=>{
          if (es_ultima) {
            this.Listo();
          }
          swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
        });
      }else if (es_ultima) {

        this.antecedentes=true;
        //this.Consultar_Preguntas_Adicionales();
        this.$router.push({name:'Examenes'});
      }
    },
    Guardar_Antecedentes(){
      this.Cargando();
      this.$http.post('solicitudes/preguntas/adicionales',this.preguntas_antecedentes)
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        if (respuestaJson.resp=='Excelente') {
          this.$router.push({name:'Examenes'});
        }else{
          swal(respuestaJson.resp,"", "error");
        }
      })
      .catch(error=>{
        this.Listo();
        swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
      });
    },
    Validar_Que_Esten_Contestadas_Todas_Las_Respuestas(){
      this.validando=true;
      var that = this;
      var respuesta=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          if (this.examen.preguntas[i].respuesta!=null) {
            respuesta=true;
          }
        }
      }
      if (respuesta && this.continuar_siguiente_pregunta_al_contestar) {
        setTimeout(function(){
          that.Cargando();
        }, 700);
        setTimeout(function(){
          that.Continuar_Siguiente_Pregunta();
          that.validando=false;
        }, 900);
      }else{
        this.validando=false;
      }
    },
    Seleccionar_Respuesta(numero_pregunta,numero,valor){
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==numero_pregunta) {
          this.examen.preguntas[i].cambio=true;
          if (this.examen.preguntas[i].respuesta==numero) {
            this.examen.preguntas[i].respuesta=null;
          }else{
            this.examen.preguntas[i].respuesta=numero;
            this.examen.preguntas[i].valor=valor;
          }
        }
      }
      this.Validar_Que_Esten_Contestadas_Todas_Las_Respuestas();
    },
    Anterior_Pregunta(){
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        //if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=false;
        //}
      }
      this.pregunta_actual--;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=true;
        }
      }
    },
    Continuar_Siguiente_Pregunta(){

      for (var i = 0; i < this.examen.preguntas.length; i++) {
        //if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=false;
        //}
      }
      this.cantidad_siguiente++;
      this.avance=(this.pregunta_actual*100)/this.total_preguntas;
      var continuar = true;
      if (this.pregunta_actual>=this.total_preguntas) {
        this.Guardar_Avance(true);
        continuar=false;
      }else if(this.cantidad_siguiente==10){
        this.cantidad_siguiente=1;
        this.Guardar_Avance();
      }
      if (continuar) {
        this.pregunta_actual++;
        for (var i = 0; i < this.examen.preguntas.length; i++) {
          if (this.examen.preguntas[i].numero==this.pregunta_actual) {
            this.examen.preguntas[i].active=true;
          }
        }
        this.Listo();
      }
    },
    Consultar_Preguntas_Adicionales(){
      this.Cargando();
      this.$http.get('solicitudes/preguntas/adicionales')
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        this.preguntas_antecedentes=respuestaJson;
        this.Listo();
      })
      .catch(error=>{
        this.Listo();
        swal("Favor de Intentar mas tarde", "Problemas para cargar las preguntas", "error");
      });
    },
    Consultar_Preguntas(){
      this.Cargando();
      this.$http.get('solicitudes/mis/examenes/depBeck')
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        if (respuestaJson.resp=='Excelente') {
          this.examen=respuestaJson.examen;
          this.fecha_hora_fin=moment(respuestaJson.fecha_hora_fin).format('LT');
          this.total_preguntas=respuestaJson.examen.preguntas.length;
          this.avance=respuestaJson.examen.avance;
          this.Buscar_Pregunta_Que_Se_Quedo();
          this.Listo();
        }else{
          this.Listo();
          swal("¡Ups!",respuestaJson.resp, "error");
        }
      })
      .catch(error=>{
        this.Listo();
        swal("Favor de Intentar mas tarde", "Problemas para cargar las preguntas", "error");
      });
    },
    Cargando(){

      this.loading='';
      this.result='d-none';
    },
    Listo(){
      this.loading='d-none';
      this.result='';
    }
  },
  computed:{
    puedo_continuar(){
      var respuesta=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          if (this.examen.preguntas[i].respuesta!=null) {
            respuesta=true;
          }
        }
      }

      if (respuesta) {
        return 1;
      }else{
        return 0;
      }
    },
    puedo_terminar(){
      var respuestas = 0;
      for (var i = 0; i < this.preguntas_antecedentes.length; i++) {
        if (this.preguntas_antecedentes[i].respuesta!=null) {
          respuestas++;
        }
      }

      if (respuestas==3) {
        return 1;
      }else{
        return 0;
      }
    },
    mostrar_tiempo_restante(){
      return this.$store.getters.getMostrar_Tiempo_Restante;
    },
    avance_total(){
      return this.$store.getters.getAvance_Total;
    },
    tiempo_restante(){
      return this.$store.getters.getTiempo_Restante;
    },
    tiempo_restante_horas(){
      return this.$store.getters.getTiempo_Restante_Horas;
    }
  },
  mounted(){
    this.Consultar_Preguntas();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Examenes/DepresionBeck/Preguntas.vue